<template>
  <h3>シーズン入場者/ボーダーライン</h3>
  season:<select v-model="season">
    <option v-for="s in seasons" :key="s">{{ s }}</option>
  </select>
  league:<select v-model="league">
    <option v-for="l in leagues" :key="l">{{ l }}</option>
  </select>
  <attendance-table msg="シーズン入場者一覧" :season="season" :league="league"/>
  <br>
  <a href="https://blog.datairoro.com/sports/">Blog</a>
  <br>
  <footer-adsense></footer-adsense>
  
</template>

<script>
import AttendaceTable from './components/AttendaceTable.vue';
import FooterAdsense from "./components/FooterAdsense.vue";

export default {
  name: 'App',
  components: {
    "attendance-table":AttendaceTable,
    "footer-adsense":FooterAdsense
  },
  data(){
    return{
      season:"2023-24",
      seasons:["2023-24","2022-23","2021-22","2020-21","2019-20","2018-19","2017-18","2016-17"],
      league:"B1",
      leagues:["All","B1","B2","B3"]
    }
  },
  mounted(){

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
